module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-wrapper"
  }, [_c('div', {
    staticClass: "dialog-wrapper-auot"
  }, [_c('span', {
    staticClass: "dialogtet"
  }, [_vm._v(_vm._s(_vm.$t('prompt')))]), _vm._v(" "), _c('span', {
    staticClass: "dialogtet-tips"
  }, [_vm._v(_vm._s(_vm.$t('completemydirecion')))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-okbtn",
    on: {
      "click": function($event) {
        _vm.openAdress($event)
      }
    }
  }, [_c('span', {
    staticClass: "pay"
  }, [_vm._v("\n                      OK\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modifyUserdata-err"
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-close",
    on: {
      "click": _vm.loginHide
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea28b14","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/complete/dialog.vue
// module id = 466
// module chunks = 1